import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  FunctionField,
  ShowButton,
  NumberField,
  Filter,
  TextInput,
  DateTimeInput,
  TopToolbar,
  AutocompleteInput,
  useGetList,
} from "react-admin";
import { JsonField } from "react-admin-json-view";
import { DateField } from "../../shared/components/index.js";

const TruncFilter = (props) => {
  const { data: mpgs } = useGetList("MerchantPaymentGateway");

  return (
    <Filter {...props}>
      {mpgs && (
        <AutocompleteInput
          source="merchant_payment_gateway_id"
          choices={mpgs}
          inputText={(record) => record.name}
          optionText="name"
          optionValue="id"
          debounce={10}
          filterToQuery={(searchText) => ({ name: searchText })}
          alwaysOn
          resettable
        />
      )}
      <TextInput source="client_phone" alwaysOn resettable />
      <DateTimeInput source="start_date" alwaysOn />
      <DateTimeInput source="end_date" alwaysOn />
    </Filter>
  );
};

const listTruncs = (props) => (
  <List actions={<TopToolbar />} filters={<TruncFilter {...props} />}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="title" />
      <ReferenceField
        source="merchant_payment_gateway_id"
        reference="MerchantPaymentGateway"
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <FunctionField
        source="client_phone"
        render={(record) => (
          <a
            style={{ color: "#1976d2", textDecoration: "none" }}
            href={`/#/CLient/${record.client_id}/show`}
          >
            {record.client_phone}
          </a>
        )}
      />
      {/* <TextField source="client_phone" /> */}
      <TextField source="description" />
      <TextField source="short_description" />
      <NumberField source="amount" />
      <JsonField
        source="transactions"
        reactJsonOptions={{
          name: null,
          collapsed: true,
          enableClipboard: false,
          displayDataTypes: false,
        }}
        sortable={false}
      />
      <FunctionField source="status" render={(record) => record.status} />
      <DateField source="created_at" />
      <DateField source="updated_at" />
      <ShowButton className="button-show" />
    </Datagrid>
  </List>
);

export default listTruncs;
